var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"tg-empty",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 106 87"}},[_c('text',{staticClass:"cls-1",attrs:{"id":"T_T","transform":"translate(0 70)"}},[_c('tspan',{attrs:{"x":"0","y":"0"}},[_vm._v("T_T")])])])}
var staticRenderFns = []

export { render, staticRenderFns }